

import {api,baseUrl} from '../config.jsx'
import Dexie from 'dexie';
import 'dexie-observable';
import 'dexie-syncable';
import './syncProtocol.js'
import setDexieHooks from './setHooks'


export const statusTexts=Dexie.Syncable.StatusTexts

const pollInterval=10


const versions = [
    {
        version: 12,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode"
        },
        
    },
    {
        version: 14,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode",
            devices: "++UID,Prefix,NextCode,Name,ShopId",
        },
        
    },
    {
        version: 15,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode",
            countries: "$$UID,EName,DName",
            cities: "$$UID,Ort,PLZ,Land",
            devices: "$$UID,Prefix,NextCode,Name,ShopId",
        },
        
    },
    {
        version: 16,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,ScanRaw,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode",
            countries: "$$UID,EName,DName",
            cities: "$$UID,Ort,PLZ,Land,*fulltext",
            devices: "$$UID,Prefix,NextCode,Name,ShopId",
        },
        
    }
    ,
    {
        version: 17,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode",
            countries: "$$UID,EName,DName",
            cities: "$$UID,Ort,PLZ,Land,*fulltext",
            devices: "$$UID,Prefix,NextCode,Name,ShopId",
        },
        
    },
    {
        version: 18,
    
        stores: { // Has the same format as https://dexie.org/docs/Version/Version.stores()
            users: "$$UID,Vorname,Nachname,email,*fulltext, *fulltextName",
            pakete: "$$UID,Paketnummer,ScanRaw,Kunde,Datum",
            shops: "$$UID,CodePraefix,NextCode",
            countries: "$$UID,EName,DName",
            cities: "$$UID,Ort,PLZ,Land,*fulltext",
            devices: "$$UID,Prefix,NextCode,Name,ShopId",
        },
        
    }



    
    ];



    export const createDB=()=>
    {
        const db =  new Dexie('locks', versions);
        versions.forEach((v)=>
            db.version(v.version).stores(v.stores)
        )
        return db
    }

    
    export const syncDB = async (db,syncStatusChanged,auth)=>
    {
 
        // sets history now, as it is undefined in first render
        db.syncable.on('statusChanged',syncStatusChanged)
        await db.open()
        setDexieHooks(db)

        return db.syncable.connect('sabine',`https://${api}.${baseUrl}/sync/`,{
            fetchOptions:
                {   
                    authorization:auth
                },
                pollInterval:pollInterval*1000
            })
    };

    export function recreateDB(db,syncStatusChanged,auth) 
    {
        return db.delete().then (()=>{
            alert( "Lokale Datenbank wurde gelöscht und wird nun neu synchronisiert. Das kann einige Minuten dauern!")
            db.open().then(()=>
            {
                syncDB(db,syncStatusChanged,auth)
            }
            ).catch((e)=>
                console.log(e)
            )
        });
    } 
